






















import { computed, defineComponent, ref } from "@vue/composition-api";
import {
  LiveChatInvitation,
  LiveChatInvitationNotificationDetails,
  LiveChatInvitationStatus,
  LiveChatInvitationSubjectType,
} from "@scrile/api-provider/dist/api/LiveChatInvitationsProvider";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import emitter from "@/lib/emitter";
import { liveNames } from "@/lib/liveHelpers";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import ContentFeedCover from "@/components/ContentFeedCover";
import FormatMoney from "@/components/FormatMoney";
import { ModalsControllerEventData } from "@/components/ModalsController/types";
import NotificationItemView from "../../NotificationItemView.vue";

export default defineComponent({
  name: "NotificationLiveChatInvitation",
  components: { BaseButton, NotificationItemView, ContentFeedCover, FormatMoney },
  props: {
    notification: { type: Object as () => Notification<LiveChatInvitationNotificationDetails>, required: true },
  },
  setup(props) {
    const type = liveNames[LiveChatInvitationSubjectType.COLLAB] ?? "";
    const invitation = ref(props.notification.details.invitation);
    const showJoin = computed(() => invitation.value.status === LiveChatInvitationStatus.NEW);

    const onClick = () => {
      emitter.emit<ModalsControllerEventData>(EVENTS.MODAL_CONTROLLER_SHOW, {
        component: "ConfirmLiveChatInvitation",
        props: {
          invitation: invitation.value,
          cb: (data: LiveChatInvitation) => (invitation.value = data),
        },
      });
    };
    return {
      type,
      onClick,
      showJoin,
    };
  },
});
